// extracted by mini-css-extract-plugin
module.exports = {"desktopMenu":"DesktopMenu-desktopMenu--816da","desktopMenuList":"DesktopMenu-desktopMenuList--bafa5","desktopMenuOverlay":"DesktopMenu-desktopMenuOverlay--6a716"};